import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
const partners = [{
  name: "Honda",
  logoSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/logo_honda.png",
  description: "Impulsando la innovación en movilidad y tecnología automotriz global."
}, {
  name: "Pizza Hut",
  logoSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/logo_pizza_hut.png",
  description: "Líder mundial en servicios de alimentación y experiencia al cliente."
}, {
  name: "Porsche",
  logoSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/logo_porsche.png",
  description: "Excelencia en ingeniería y diseño de alto rendimiento deportivo."
}, {
  name: "RE/MAX",
  logoSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/logo_remax.png",
  description: "La red inmobiliaria más grande del mundo conectando hogares."
}, {
  name: "Microsoft",
  logoSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/logo_microsoft.png",
  description: "Transformación digital y soluciones de software empresarial."
}, {
  name: "Samsung",
  logoSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/logo_samsung.png",
  description: "Líder en electrónica de consumo y tecnología de vanguardia."
}, {
  name: "Toyota",
  logoSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/logo_toyota.png",
  description: "Referente en calidad automotriz y sistemas de producción eficientes."
}, {
  name: "Amazon",
  logoSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/logo_amazon.png",
  description: "Innovación constante en servicios en la nube y logística global."
}];
export default function TrustedByLeadingCompanies() {
  return;
}